import { c as _c } from "react/compiler-runtime";
import { cva, type VariantProps } from 'class-variance-authority';
import { cn } from '@/lib/utils';
const footerColumnVariants = cva('flex flex-col', {
  variants: {
    spacing: {
      default: 'gap-1.5',
      compact: 'gap-1'
    }
  },
  defaultVariants: {
    spacing: 'default'
  }
});
type NavLink = {
  label: string;
  href: string;
  external?: boolean;
};
interface FooterColumnProps extends VariantProps<typeof footerColumnVariants> {
  title: string;
  links: NavLink[];
  LinkComponent: React.ComponentType<{
    href: string;
    children: React.ReactNode;
    className?: string;
  }>;
  className?: string;
}
export function FooterColumn(t0) {
  const $ = _c(14);
  const {
    title,
    links,
    LinkComponent,
    spacing,
    className
  } = t0;
  let t1;
  if ($[0] !== className || $[1] !== spacing) {
    t1 = cn(footerColumnVariants({
      spacing
    }), className);
    $[0] = className;
    $[1] = spacing;
    $[2] = t1;
  } else {
    t1 = $[2];
  }
  let t2;
  if ($[3] !== title) {
    t2 = <li className="mb-2.5 font-bold text-[1.375rem]">{title}</li>;
    $[3] = title;
    $[4] = t2;
  } else {
    t2 = $[4];
  }
  let t3;
  if ($[5] !== LinkComponent || $[6] !== links) {
    let t4;
    if ($[8] !== LinkComponent) {
      t4 = link => <li key={link.href}>{link.external ? <a href={link.href} target="_blank" rel="noopener noreferrer" className="transition-all duration-300 hover:underline">{link.label}</a> : <LinkComponent href={link.href} className="transition-all duration-300 hover:underline">{link.label}</LinkComponent>}</li>;
      $[8] = LinkComponent;
      $[9] = t4;
    } else {
      t4 = $[9];
    }
    t3 = links.map(t4);
    $[5] = LinkComponent;
    $[6] = links;
    $[7] = t3;
  } else {
    t3 = $[7];
  }
  let t4;
  if ($[10] !== t1 || $[11] !== t2 || $[12] !== t3) {
    t4 = <ul className={t1}>{t2}{t3}</ul>;
    $[10] = t1;
    $[11] = t2;
    $[12] = t3;
    $[13] = t4;
  } else {
    t4 = $[13];
  }
  return t4;
}